import * as dayjs from "dayjs";
import { formatSlot } from "./FormatUtils";

const diffFromToday = date => {
  return date.startOf("day").diff(dayjs().startOf("day"), "days");
};

const isToday = date => {
  return diffFromToday(date) === 0;
};

const isTomorrow = date => {
  return diffFromToday(date) === 1;
};

export const dayjsDate = date => {
  return dayjs(date);
};

export const weekDay = date => {
  const paramDate = dayjsDate(date);
  if (isToday(paramDate)) {
    return "Today";
  }
  if (isTomorrow(paramDate)) {
    return "Tomorrow";
  }
  return paramDate.format("ddd");
};

// "30 Sep" (copy rules: day before month)
export const dayMonth = date => {
  return dayjsDate(date).format("D MMM");
};

// "2:30 – 5:30 pm" (redesign copy rule)
export const getDeliveryTime = (start, end) => formatSlot(start, end);

export const getSlotDayTimeId = slotTime => {
  return slotTime.id + "||" + slotTime.start + "||" + slotTime.end;
};

// "Wed, 30 Sep" this year, "Wed, 30 Sep 2025" otherwise
export const readableDate = date => {
  const d = dayjsDate(date);
  return d.format(
    d.year() === dayjs().year() ? "ddd, D MMM" : "ddd, D MMM YYYY"
  );
};

export const readableTime = date => {
  return dayjsDate(date).format("h:mm a");
};

export function isSameOrAfterNow(date) {
  return new Date() <= new Date(date);
}

export function isBetweenDates(startDate, endDate) {
  return new Date() < new Date(endDate) && new Date() >= new Date(startDate);
}

export function timeDiffBreakdown(endDate) {
  let total_seconds = dayjsDate(endDate).diff(new Date(), "second");
  let minute = Math.trunc(total_seconds / 60);
  let hour = Math.trunc(minute / 60);
  let day = Math.trunc(hour / 24);
  if (day > 0) {
    day = dayMonth(endDate);
  }
  let timeDiff = {
    day,
    hour,
    minute: minute - hour * 60,
    second: total_seconds - Math.trunc(minute) * 60
  };
  return timeDiff;
}

// Header ETA ("Today 2:30 pm" / "In 45 min"), from the vendor record loaded
// on every page: express ETA when express is running, else the start of the
// first available slot in vendor.delivery_option.
export const nextDeliveryLabel = (vendor, expressStatus) => {
  if (!vendor) return "";
  if (expressStatus && expressStatus !== "off") {
    const minutes = Number(vendor.express_delivery_minutes);
    if (minutes > 0) return `In ${minutes} min`;
  }
  const days = Array.isArray(vendor.delivery_option)
    ? vendor.delivery_option
    : [];
  for (let i = 0; i < days.length; i += 1) {
    const slots = (days[i] && days[i].timeSlots) || [];
    const slot = slots.find(s => s && s.is_available && s.start);
    if (slot) {
      const start = dayjsDate(slot.start);
      if (start.isValid()) {
        return `${weekDay(days[i].date || slot.start)} ${start.format(
          start.minute() ? "h:mm a" : "h a"
        )}`;
      }
    }
  }
  return "";
};
